import React, {useState} from 'react';
import './Planning.scss';
import PGE_LOGO from '../../assets/pge_logo.png';
import PgePlanning from './PgePlanning';

const Planning = () => {
  const [tab, setTab] = useState(1);

  const changeTab = tabId => {
    if (tabId !== tab) {
      setTab(tabId);
    }
  };

  return (
    <div className='Planning'>
      <div className='tabBar'>
        <div className={tab === 1 ? 'tabButton--selected' : 'tabButton'} onClick={() => changeTab(1)}>
          <img src={PGE_LOGO} className='logo' alt='logo' />
        </div>
      </div>
      <div className='tabContent'>
        {tab === 1
          ? <PgePlanning />
          : null
        }
      </div>
    </div>
  );
};

export default Planning;
